import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import ErrorMessage from "@Components/ErrorMessage";

import { Field } from "formik";
import "date-fns";
import MomentUtils from "@date-io/moment";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
} from "@material-ui/pickers";
import { InputLabel } from "@material-ui/core";

import useStyles from "assets/jss/material-dashboard-react/components/customDatepickerStyle";
import { format } from "date-fns";

const TimePicker = (props) => {
  const { name, label, required, errorMessage,emptyLabel, ...rest } = props;
  const classes = useStyles();
  return (
    <Field name={name}>
      {(props) => {
        // eslint-disable-next-line react/prop-types,no-unused-vars
        const { field, form, meta } = props;
        // eslint-disable-next-line react/prop-types
        const { setFieldValue } = form;
        // eslint-disable-next-line react/prop-types
        const { value } = field;
        let time = value;
        if (value && typeof value !== "object") {
          time = new Date();
          let splittedTime = value.split(":");
          time.setHours(splittedTime[0]);
          time.setMinutes(splittedTime[1]);
          time.setSeconds(splittedTime[2]);
        }
        return (
          <>
            <InputLabel
              htmlFor={name}
              className={clsx(classes.label, {
                [classes.error]: errorMessage || (meta.error && meta.touched),
              })}
            >
              { label}
              {required ? <span style={{ color: "red" }}> *</span> : null}
            </InputLabel>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <KeyboardTimePicker
                inputVariant="outlined"
                className={classes.root}
                id={name}
                format="HH:mm:ss"
                views={['hours', 'minutes', 'seconds']}
                value={time}
                emptyLabel={emptyLabel ? emptyLabel : "HH:mm:ss"}
                /* eslint-disable-next-line react/prop-types */
                allowKeyboardControl = {false}

                onKeyDown={(e)=>
                  e.preventDefault()
                }
                onChange={(value) =>
                  setFieldValue(name, format(value.toDate(), "HH:mm:ss"))
                }
                KeyboardButtonProps={{
                  "aria-label": "change time",
                }}
                DialogProps={{ className: classes.dialogStyle }}
                InputProps={{ className: !value ? classes.emptyLabel : null }}
                {...rest}
              />
            </MuiPickersUtilsProvider>
            {errorMessage || (meta.error && meta.touched) ? (
              <ErrorMessage
                message={errorMessage ? errorMessage : meta.error}
              />
            ) : null}
          </>
        );
      }}
    </Field>
  );
};

TimePicker.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  errorMessage: PropTypes.string,
  field: PropTypes.object,
  meta: PropTypes.object,
  required: PropTypes.bool,
  emptyLabel: PropTypes.string,
};

export default TimePicker;
